import { gql } from '@apollo/client';
import INSTANT_REPORT_FRAGMENT from '../fragments/instantReportFragment';

const GET_UNREVIEWED_REPORTS = gql`
  query getUnreviewedReports($input: GetUnreviewedReportsInput) {
    getUnreviewedReports(input: $input) {
      isSuccess
      message
      reports {
        ...InstantReportFragment
      }
    }
  }

  ${INSTANT_REPORT_FRAGMENT}
`;

export default GET_UNREVIEWED_REPORTS;
